import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { OrganizationClient, OrganizationView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class OrganizationService {
    constructor(private readonly client: OrganizationClient) {}

    async getById(id: number): Promise<OrganizationView> {
        return await lastValueFrom(this.client.organizationGetById(id));
    }
}
